import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuidePartnerTagForm from '../containers/CareGuidePartnerTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuidePartnerTagAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuidePartnerTagAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_partner_tag_route_add')} />
          <CareGuidePartnerTagForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuidePartnerTagAddScreen;

Logger.log('silly', `CareGuidePartnerTagAddScreen loaded.`);